import { toast } from 'react-hot-toast';

import axios from 'axios';

import { Object } from 'types';

import * as cognito from 'lib/cognito';
import { priceTypeStore } from 'lib/priceTypeStore';
import { tokenStore } from 'lib/tokenStore';

async function getSession() {
  const session = await cognito.getSession();

  return session;
}

let isLoggingOut = false;

function forceLogout() {
  if (isLoggingOut) return;
  isLoggingOut = true;

  cognito.signOut();
  tokenStore.clearTokens();
  priceTypeStore.clearPriceType();
  toast.error('Session expired. Please sign in again.', {
    id: 'session-expired',
    duration: 5000,
  });
  setTimeout(() => {
    window.location.href = '/login';
  }, 1500);
}

const fetch = (url?: string, headers: Object = {}) => {
  const defaultOptions = {
    baseURL: url || `${process.env.REACT_APP_API_URL}/api`,
    headers: {
      'Content-type': 'application/json',
      ...headers,
    },
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async (config) => {
    try {
      const session: any = await getSession();

      if (session && session.accessToken) {
        tokenStore.setTokens(
          session.accessToken.jwtToken,
          session.refreshToken.token,
          session.idToken.jwtToken
        );

        config.headers!.Authorization = `Bearer ${session.accessToken.jwtToken}`;
      }
    } catch (e) {
      if (tokenStore.hasToken()) {
        forceLogout();
      }
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // eslint-disable-next-line no-console
      console.error(`Api Error
        Status: ${error?.response?.data?.apierror?.status}
        Message: ${error?.response?.data?.apierror?.message}
      `);

      if (error?.response?.status === 401 && tokenStore.hasToken()) {
        forceLogout();
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export { fetch };
